import React from 'react'

// ==========================================
// COMPONENTES UI COMPARTIDOS
// ==========================================

export function Button({ children, onClick, variant = 'primary', className = '', ...props }: { [x: string]: any; children: any; onClick: any; variant?: string; className?: string }) {
    const base = "px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
    const variants: Record<string, string> = {
        primary: "bg-gradient-to-r from-neon-blue to-indigo-600 text-white hover:opacity-90 shadow-lg shadow-neon-blue/20",
        danger: "bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20",
        ghost: "text-gray-400 hover:text-white hover:bg-white/5",
        success: "bg-neon-green/10 text-neon-green border border-neon-green/20 hover:bg-neon-green/20"
    }
    return <button onClick={onClick} className={`${base} ${variants[variant] || ''} ${className}`} {...props}>{children}</button>
}

export function Input({ label, ...props }: { label: string;[x: string]: any }) {
    return (
        <div className="space-y-1">
            <label className="text-sm text-gray-400 ml-1">{label}</label>
            <input
                className="w-full bg-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-neon-blue focus:ring-1 focus:ring-neon-blue transition-all"
                {...props}
            />
        </div>
    )
}

export function Card({ children, className = '', ...props }: { children: any; className?: string;[x: string]: any }) {
    return <div className={`glass-panel rounded-xl p-6 ${className}`} {...props}>{children}</div>
}

export function Badge({ status }: { status: string }) {
    const styles: Record<string, string> = {
        active: 'bg-neon-green/10 text-neon-green border-neon-green/20',
        inactive: 'bg-gray-500/10 text-gray-400 border-gray-500/20',
        revoked: 'bg-red-500/10 text-red-500 border-red-500/20',
        expired: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
        pending: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
        delivered: 'bg-purple-500/10 text-purple-400 border-purple-500/20',
        executed: 'bg-neon-green/10 text-neon-green border-neon-green/20'
    }
    return (
        <span className={`px-2 py-1 rounded text-xs font-mono border ${styles[status] || styles.inactive}`}>
            {status?.toUpperCase()}
        </span>
    )
}
